import React, { Component } from 'react'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import moment from 'moment'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import './Schedules.custom.scss'

import Professional from '@services/Professional'
import stringToColor from '@utilities/stringToColor'
import TimeZoneSelector from '@modules/formFields/SelectTimeZoneField'
import Shift from '@modules/admin/schedules2/Shift'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'

dayjs.extend(utc)
dayjs.extend(timezone)

export class Schedules extends Component {
  onClickProfessional = (professional) => {
    if (this.state.selectedProfessional && this.state.selectedProfessional.id === professional.id) {
      this.setState({ selectedProfessional: undefined })
      return null
    }
    this.setState({ selectedProfessional: professional })
  }

  onChangeViewOfBigCalendar = (dateRangeThingy) => {
    if (!!dateRangeThingy.start && !!dateRangeThingy.end) {
      this.setState({
        visibleDates: this.getDaysFromRange({
          start: dateRangeThingy.start,
          end: dateRangeThingy.end,
        }),
      })
    }

    if (!!dateRangeThingy.length) {
      this.setState({
        visibleDates: dateRangeThingy,
      })
    }
    return null
  }

  onDragShift = (event) => {
    if (!this.state.selectedProfessional) {
      window.alert('select a professional')
      return null
    }

    return this.postShift(event)
  }

  onClickShift = (shift) => {
    return this.setState({ selectedShift: shift })
  }

  postShift = (shift) => {
    //TODO: make call to backend
    return new Promise((resolve) =>
      resolve({
        id: Object.values(this.state.shifts).length + 1,
        professional: this.state.selectedProfessional,
        ...shift,
      })
    ).then((responseShift) =>
      this.setState((oldState) => ({
        shifts: {
          ...oldState.shifts,
          [responseShift.id]: responseShift,
        },
        selectedShift: responseShift,
      }))
    )
  }

  deleteShift = (shift) => {
    return new Promise((resolve) => resolve(shift)).then((responseShift) =>
      this.setState((oldState) => {
        let { [responseShift.id]: deletedShift, ...everyOtherShift } = oldState.shifts
        return { shifts: everyOtherShift, selectedShift: undefined }
        // delete oldState.shifts[responseShift.id]
        // return {shifts: oldState.shifts}
      })
    )
  }

  getDaysFromRange = ({ start, end }) => {
    let days = []
    let day = start

    while (day <= end) {
      days.push(day)
      day = moment(day).add(1, 'days').toDate()
    }

    return days
  }

  constructor() {
    super()
    this.state = {
      specialities: undefined,
      professionals: [],
      shifts: {},
      selectedTimezone: dayjs.tz.guess(),
      selectedSpeciality: undefined,
      selectedProfessional: undefined,
      selectedShift: undefined,
      visibleDates: this.getDaysFromRange({
        start: moment().startOf('week').toDate(),
        end: moment().endOf('week').toDate(),
      }),
    }
  }

  componentDidMount() {
    Professional.professional
      .index({ limit: 1000 })
      .then(({ data }) => this.setState({ professionals: data, shifts: {} }))
  }

  render() {
    let visibleShifts = Object.values(this.state.shifts)

    if (this.state.selectedSpeciality) {
      visibleShifts = visibleShifts.filter(
        (shift) => shift.professional.speciality_id === this.state.selectedSpeciality.id
      )
    }

    if (this.state.selectedProfessional) {
      visibleShifts = visibleShifts.filter((shift) => shift.professional.id === this.state.selectedProfessional.id)
    }

    return (
      <div className={'Schedules'} style={{ display: 'flex' }}>
        <div className={'calendar'} style={{ height: 'calc(100vh - 100px)' }}>
          <Calendar
            selectable
            localizer={momentLocalizer(moment.tz.setDefault(this.state.selectedTimezone))}
            events={visibleShifts}
            defaultView={Views.WEEK}
            titleAccessor={(event) => event.professional.name}
            onSelectEvent={this.onClickShift}
            onSelectSlot={this.onDragShift}
            onRangeChange={this.onChangeViewOfBigCalendar}
            eventPropGetter={(event) => ({
              style: { backgroundColor: stringToColor(event.professional.name) },
            })}
          />
        </div>

        <div className={'factorial'}>
          {this.state.selectedProfessional &&
            this.state.visibleDates.map((day, key) => (
              <div key={key}>
                <div>{day.toDateString()}</div>
                {visibleShifts
                  .filter((shift) => shift.start.toDateString() === day.toDateString())
                  .map((shift) => (
                    <Shift
                      {...shift}
                      key={shift.id}
                      handleShift={this.postShift}
                      deleteShift={this.deleteShift}
                      active={this.state.selectedShift && this.state.selectedShift.id === shift.id}
                    />
                  ))}
                <Shift date={day} handleShift={this.postShift} creatable />
              </div>
            ))}
        </div>

        <div className={'rightSidebar'}>
          <TimeZoneSelector
            input={{
              value: this.state.selectedTimezone,
              onChange: (timeZone) => this.setState({ selectedTimezone: timeZone }),
            }}
          />
          <SelectSpecialityField
            input={{
              value: this.state.selectedSpeciality,
              onChange: (selectedOption) =>
                this.setState({ selectedSpeciality: selectedOption, selectedProfessional: undefined }),
            }}
          />
          <div>
            {this.state.professionals
              .filter((professional) =>
                this.state.selectedSpeciality ? professional.speciality_id === this.state.selectedSpeciality.id : true
              )
              .map((professional) => (
                <div key={professional.id} onClick={() => this.onClickProfessional(professional)}>
                  {this.state.selectedProfessional && this.state.selectedProfessional.id === professional.id ? (
                    <b>{professional.name}</b>
                  ) : (
                    <>{professional.name}</>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }
}
